import { cardConstants } from "../constants/cardConstants"

const initialState = {
  cards: [],
  creatingCard: false,
  fetchingCard: false
}

export function cards(state = initialState, action) {
  switch (action.type) {
    case cardConstants.CREATE_CARD_REQUEST:
      return {
        ...state,
        creatingCard: true
      }

    case cardConstants.CREATE_CARD_SUCCESS:
      return {
        ...state,
        creatingCard: false,
        newCardId: action.id
      }

    case cardConstants.CREATE_CARD_FAILURE:
      return {
        ...state,
        creatingCard: false,
        cardError: action.error
      }
    case cardConstants.FETCH_CARD_REQUEST:
      return {
        ...state,
        fetchingCard: true
      }

    case cardConstants.FETCH_CARD_SUCCESS:
      return {
        ...state,
        fetchingCard: false,
        card: action.card
      }

    case cardConstants.FETCH_CARD_FAILURE:
      return {
        ...state,
        fetchingCard: false,
        cardError: action.error
      }

    case cardConstants.FETCH_CARD_PASSAGE_REQUEST:
      return {
        ...state,
        fetchingCardPassage: true
      }

    case cardConstants.FETCH_CARD_PASSAGE_SUCCESS:
      return {
        ...state,
        fetchingCardPassage: false,
        cardPassage: action.passage
      }

    case cardConstants.FETCH_CARD_PASSAGE_FAILURE:
      return {
        ...state,
        fetchingCardPassage: false,
        cardPassageError: action.error
      }

    case cardConstants.FETCH_CARD_DECKS_REQUEST:
      return {
        ...state,
        fetchingCardDecks: true
      }

    case cardConstants.FETCH_CARD_DECKS_SUCCESS:
      return {
        ...state,
        fetchingCardDecks: false,
        cardDecks: action.decks
      }

    case cardConstants.FETCH_CARD_DECKS_FAILURE:
      return {
        ...state,
        fetchingCardDecks: false,
        cardDecksError: action.error
      }

    case cardConstants.UPDATE_CARD_DATA_REQUEST:
      return {
        ...state,
        updatingCard: true,
        updateType: action.property
      }

    case cardConstants.UPDATE_CARD_DATA_SUCCESS:
      return {
        ...state,
        updatingCard: false,
        updateType: "",
        card: {
          ...state.card,
          [action.card.property]: action.card.value
        }
      }

    case cardConstants.UPDATE_CARD_DATA_FAILURE:
      return {
        ...state,
        updatingCard: false,
        updateError: action.error,
        updateType: ""
      }

    case cardConstants.UPDATE_CARD_REQUEST:
      return {
        ...state,
        updatingCard: true
      }

    case cardConstants.UPDATE_CARD_SUCCESS:
      return {
        ...state,
        updatingCard: false,
        card: {
          ...state.card,
          ...action.card
        }
      }

    case cardConstants.UPDATE_CARD_FAILURE:
      return {
        ...state,
        updatingCard: false,
        updateError: action.error
      }

    case cardConstants.DELETE_CARD_REQUEST:
      return {
        ...state,
        deletingCard: true
      }

    case cardConstants.DELETE_CARD_SUCCESS:
      return {
        ...state,
        deletingCard: false
      }

    case cardConstants.DELETE_CARD_FAILURE:
      return {
        ...state,
        deletingCard: false,
        deleteError: action.error
      }

    case cardConstants.ADD_CARD_TO_DECKS_REQUEST:
      return {
        ...state,
        addingCardtoDeck: true
      }

    case cardConstants.ADD_CARD_TO_DECKS_SUCCESS:
      return {
        ...state,
        addingCardtoDeck: false
      }
    case cardConstants.ADD_CARD_TO_DECKS_FAILURE:
      return {
        ...state,
        addingCardtoDeck: false,
        addingError: action.error
      }

    case cardConstants.UPDATE_CARDS_PASSAGE_REQUEST:
      return {
        ...state,
        updatingCardsPassage: true
      }

    case cardConstants.UPDATE_CARDS_PASSAGE_SUCCESS:
      return {
        ...state,
        updatingCardsPassage: false
      }

    case cardConstants.UPDATE_CARDS_PASSAGE_FAILURE:
      return {
        ...state,
        updatingCardsPassage: false,
        updatingCardsPassageError: action.error
      }
    case cardConstants.FETCH_ALL_CARDS_REQUEST:
      return {
        ...state,
        fetchingAllCards: true
      }

    case cardConstants.FETCH_ALL_CARDS_SUCCESS:
      return {
        ...state,
        fetchingAllCards: false,
        cards: action.cards
      }
    case cardConstants.FETCH_ALL_CARDS_FAILURE:
      return {
        ...state,
        fetchingAllCards: false,
        errorFetching: action.error
      }

    default:
      return state
  }
}
